import React, {useEffect} from "react";
// import { Switch, Route, Redirect } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import routes from "../routes/routeSupport";
// import WohlerLogo from "assets/img/wohler_logo_295x117.png";
import WohlerLogo from "assets/img/mavric_logo_new.png";
import WohlerShortLogo from "assets/img/dashboard/wohler.png";
import MDrawer from 'layouts/m-drawer.js';


export default function Support({ ...rest }) {
  let selectedTile = "";
  if(rest !== undefined && rest.location !== undefined && rest.location.state !== undefined){
    selectedTile = rest.location.state.name;
  }

  const isAuthUser  = useSelector(state => state.isAuthUser);
  const Role        = useSelector(state => state.role);
  const UserId      = useSelector(state => state.userid);
  console.log("Support Page Role : ", Role);
  const isSupport = (Role === "support") ? true : false;

  console.log("isSupport Role : ", isSupport);
  
  let history = useHistory();
  
  
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  
  if(!isSupport) {
    history.push('/login');
  }

  return (
    <div>
     
      {<MDrawer 
        routes={routes}
        logo={WohlerLogo}
        slogo={WohlerShortLogo}
        preSelected={selectedTile}
      />}
      
        
    </div>
  );
}